import { forgotPasswordRequest, msalInstance } from '@utils';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
} from '@azure/msal-browser';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/app';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { basename } from './app/routes/basename';

const queryClient = new QueryClient();

msalInstance.initialize().then(async () => {
  await msalInstance.handleRedirectPromise();

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      msalInstance.setActiveAccount(payload.account);
    }
    if (event.eventType === EventType.LOGIN_FAILURE) {
      if (event.error?.message.includes('AADB2C90118')) {
        msalInstance.loginRedirect(forgotPasswordRequest);
      }
    }
  });

  // Redirect root and callback paths to /dashboard
  if (
    window.location.pathname === '/' ||
    window.location.pathname === '/callbacks'
  ) {
    window.location.replace(basename);
    return;
  }

  createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
});
